import React, { type ReactNode } from 'react';

import {
	Router,
	type RouterProps,
} from '@jira/platform__routing-router-components/src/ui/router/index.tsx';

/**
 * A special component dedicated to ensure correct structure of the SPA router.
 */
export const SpaRouter = ({
	routerProps,
	before,
	children,
	after,
}: {
	before?: ReactNode;
	children: ReactNode;
	after?: ReactNode;
	routerProps: RouterProps;
}): React.JSX.Element => (
	<Router {...routerProps}>
		{before}
		{children}
		{after}
	</Router>
);
